<script>
import ModuleTitle from '../common/ModuleTitle.vue'

import { getShadowColor } from '@/utils/modules/getStyles'
import { filtersRichtext, textLenHandler } from '@/utils/common'

export default {
  name: 'Comp44',
  components: { ModuleTitle },
  props: {
    moduleOption: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      path: this.$route.path
    }
  },
  methods: {
    getShadowColor, filtersRichtext, textLenHandler,
    onModuleItem(v) {
      this.$emit('onModuleItem', v)
    }
  }
}
</script>

<template>
  <div class="modules-id-44">
    <module-title :title="moduleOption.title" margin-bottom="14" />
    <div class="comp-transverse-2 modules-id-44-content">
      <div
        v-for="(v, i) in moduleOption.list.slice(0, 4)"
        :key="`modules-id-44-item-${i}`"
        :class="['item', `item-${i}`]"
        @click="onModuleItem(v)"
      >
        <div class="img-box">
          <el-image class="item-img" :src="v.photo | imgPath" alt="img" fit="cover" />
        </div>
        <div class="memo-box">
          <p class="item-headline">“{{ v.headline | textLenHandler(6) }}”</p>
          <p class="item-memo">{{ textLenHandler(filtersRichtext(v.memo), 30) }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.modules-id-44-content {
  display: flex;
  column-gap: 30px;
  .item {
    width: 155px;
    height: 350px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    background: url('~imgs/modules/comp42t2-bg.webp') no-repeat center;
    background-size: 100% 100%;
  }
  .item-0 {
    margin-top: 5px;
  }
  .item-1 {
    margin-top: 30px;
  }
  .item-3 {
    margin-top: 20px;
  }
  .img-box {
    width: 113px;
    height: 77px;
    background: url('~imgs/modules/comp42t2-border.png') no-repeat center;
    background-size: 100% 100%;
    margin-top: 80px;
    display: grid;
    place-items: center;
    .item-img {
      width: 107px;
      height: 71px;
    }
  }
  .memo-box {
    width: 155px;
    height: 200px;
    display: flex;
    justify-content: center;
    column-gap: 8px;
    .item-headline {
      font-size: 14px;
      font-weight: bold;
      color: #228E76;
      writing-mode: vertical-lr;
      font-family: siyuansong;
      letter-spacing: 2px;
      margin-left: 10px;
    }
    .item-memo {
      width: 90px;
      height: 120px;
      font-size: 10px;
      font-weight: bold;
      color: #268877;
      margin: 10px 0 0 6px;
      writing-mode: vertical-lr;
    }
  }
}
</style>
